import React from 'react'
import Navbar from '../components/Navbar'
import MainPic from '../components/MainPic'

const Home = () => {
  return (
    <div>
      <Navbar/>
      <MainPic/>
    </div>
  )
}

export default Home
